import { useMutation } from '@tanstack/react-query';

import { CustomNotification } from 'common/components';

import { addSelectedProductToApl } from 'services/apl';

import { useIntl } from 'react-intl';
import messagesProduct from 'i18n/messages/product';

export const useAddSelectedProductToApl = () => {
  const intl = useIntl();

  return useMutation({
    mutationKey: 'add-selected-product-to-apl',
    mutationFn: addSelectedProductToApl,
    onSuccess: async (result) => {
      if (result?.isSuccess) {
        CustomNotification.success(
          intl.formatMessage(messagesProduct.addProductToAplSuccess)
        );
      } else {
        CustomNotification.error(
          result?.message ||
            intl.formatMessage(messagesProduct.addProductToAplError)
        );
      }
    },
    onError: () => {
      CustomNotification.error(
        intl.formatMessage(messagesProduct.addProductToAplError)
      );
    },
  });
};
